export const helpContents = {
  patient_matching: {
    title: '患者の取り込みについて',
    content: `
💡 **確認ポイント**

#### 1. 読み取り結果を確認
メイン画面の\`「患者一致情報」\`タブで読み取り結果を確認ください

---

#### 2-1. その中に誤りがある場合
→ 該当の項目を押して、その旨を報告してください <br>
（項目を押すと**\`✔︎マーク\`**が付きます。これで報告完了です。）<br>
→ 「まもる君」が学習し、精度が向上して参ります

---

#### 2-2. 読み取りが正しい場合
→ 「まもる君」の想定している患者一致情報がレセコンと異なる可能性があります。<br>
→ レセコンの患者紐付け設定を確認してください。必要に応じてレセコンベンダー様へお問い合わせください

---

**ヒント**:<br>\`患者カナ氏名・性別・生年月日\`が一致する事が、患者一致において必要である事が多いです
`,
  },
  doctor_matching: {
    title: '医師名がレセコンに認識されない',
    content: `
**💡 確認手順**

#### 1. 読み取り結果を確認
メイン画面の\`「基本情報」\`タブで読み取り結果を確認ください

---

#### 2-1. 誤りがある場合
→ 該当の項目を押して、その旨を報告してください <br>
（項目を押すと**\`✔︎マーク\`**が付きます。これで報告完了です。）<br>
→ 「まもる君」が学習し、精度が向上して参ります

---

#### 2-2. 読み取りが正しい場合
→ レセコンの医師名登録を確認してください  
→ 必要に応じてレセコンベンダーへお問い合わせください

---

**ヒント**: <br>医師名の\`表記ゆれ（漢字、ひらがな、カタカナ）\`による不一致にもご注意ください
`,
  },
  youhou_matching: {
    title: '用法の認識について',
    content: `
**💡 確認手順**

#### 1. レセコンが用法を認識せず、毎回入れ直しになっている場合
→ レセコンの\`「QR用法マスタ登録」\`を行うと改善する場合があります  
→ \`「QR用法マスタ登録」\`の手順については、レセコンのマニュアルを参照頂くか、レセコンベンダー様へお問い合わせください

---

#### 2. コメントに入っていてほしいものが用法に入っている場合（もしくはその逆）
→ 該当の用法とコメントを、このアプリ上からタップして報告してください  <br>
（項目を押すと**\`✔︎マーク\`**が付きます。これで報告完了です。）<br>
→ \`よくあるご質問 > その他 > まもる君への学習要望\` から、どのような形で用法・コメントが出力されると良いかを「まもる君」に送信ください
`,
  },
  quicksync_check: {
    title: 'mediLabQuickSyncが動いているかの確認方法',
    content: `
#### 1. タスクトレイアイコンの確認
→ パソコン画面右下のタスクトレイに\`mediLabQuickSync\`のアイコンが表示されているか確認してください

---

#### 2. 表示されていない場合
→ Windows左下の検索窓などから\`mediLabQuickSync\`と検索し、アプリを起動ください<br>
→ ログイン画面が表示された場合、mediLabアカウントの\`id, パスワード\`を入力して、ログインを実施ください

---

**ヒント**: <br>mediLabQuickSyncはPC起動時に自動的に立ち上がるするよう設定されていますが、Windowsアップデート後などに起動しないことがあります。
`,
  },
  network_check: {
    title: 'ネットワークが繋がっているかの確認方法',
    content: `
#### 1. インターネット接続の確認
→ ブラウザを開いて、\`https://medilabai.com\`にアクセスできるか確認してください
→ ページへのアクセスが可能であれば、インターネット接続は問題ございません

---

#### 2. まもる君サーバーへの接続確認
→ パソコン画面右下のタスクトレイに\`mediLabQuickSync\`のアイコンがを右クリックして\`「接続状況」\`を実行してください<br>
→ \`「接続成功」\`と表示されれば正常です <br>
※ バージョンにより、少し記載が異なる可能性がございます

---

**ヒント**: <br>
ネットワーク不通は一時的なものである場合が多いです。少し時間をおいてから再度お試しください
`,
  },
}
